import * as types from './types'
import { IResponse } from '@cbgms/api'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import {
  SupportMediaItemResponse,
  SupportMediaOutput,
  SupportMediaParams,
  SupportPostMediaParams,
  getMediaItemRequest,
  postMediaItemRequest
} from './request'

export const postPrivateMediaItem = (postMediaParams: SupportPostMediaParams) =>
  AsyncAction<IResponse<SupportMediaItemResponse>>({
    type: [types.UPDATE_PRIVATE_MEDIA, types.UPDATE_PRIVATE_MEDIA_SUCCESS, types.UPDATE_PRIVATE_MEDIA_FAILED],
    payload: {
      api: 'support',
      request: postMediaItemRequest(postMediaParams)
    }
  })

export const getPrivateMediaItem = ({ category, companyUUID, subCategory, fileName }: SupportMediaParams) =>
  AsyncAction<IResponse<SupportMediaOutput>>({
    type: [types.GET_PRIVATE_MEDIA, types.GET_PRIVATE_MEDIA_SUCCESS, types.GET_PRIVATE_MEDIA_FAILED],
    payload: {
      api: 'support',
      request: getMediaItemRequest({ category, companyUUID, subCategory, fileName })
    }
  })
